import namespace from './namespace';
import Dashboard from './containers/Dashboard';
import {
    reducer as insightKpiReducer,
    type InsightKpiState,
    insightKpiInitialState
} from './insightKpiActions';

export type State = {
    [namespace]: InsightKpiState;
}
const reducers = {
    [namespace]: insightKpiReducer,
};
const initialState = {
    [namespace]: insightKpiInitialState,
};

export { Dashboard, namespace, reducers, initialState };
